import { openZohoChat } from '../utils/openZohoChat';

export default function ChatBar() {
  return (
    <div className="chat-bar" role="complementary" aria-label="Quick support">
      <button type="button" className="chat-bar__chat chat-bar__chat--solo" onClick={openZohoChat}>
        Chat Now
      </button>
    </div>
  );
}
